import React from "react";
import masterData from "../../lib/masterData";

export const campaign = ({ type, asset }) => {
  return (
    <div>
      {asset.campaignsVacant && asset.campaignsVacant.map((campaignId, index) => {
        const campaign = masterData.campaign.byId[campaignId];
        if (!campaign) {
          return (
            <div>
              指定されたキャンペーン
              {campaignId}
              が見つかりませんでした。
            </div>
          );
        }
        return (
          <div className="campaign" id={"campaign_detail" + campaignId} key={index}>
            <div className="pop">キャンペーン中！</div>
            <div className="content">
              <div className="detail">
                <div className="title">{campaign.campaignName}</div>
                <div
                  className="text"
                  dangerouslySetInnerHTML={{ __html: campaign.webTokuten }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/detail/campaign.jsx